<template>
  <div class="news-wrapper">
    <img src="../../../assets/img/header/header_press.png" alt="" />
    <div class="news-meta">
      <PretendardText class="title">{{ title }}</PretendardText>
      <PretendardText class="date">{{ date }}</PretendardText>
    </div>
  </div>
</template>

<script>
import PretendardText from "@/components/atoms/text/PretendardText.vue";

export default {
  name: "NewsCard",
  components: { PretendardText },
  props: {
    title: String,
    date: String,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.news-wrapper {
  display: flex;
  flex-direction: column;

  & img {
    width: 100%;
    height: 214px;
    object-fit: cover;
    border-radius: 10px 10px 0 0;
  }

  & .news-meta {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 15px;
    background: #f7fafc;
    border-radius: 0 0 10px 10px;

    & .title {
      color: #044a85;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 130%;
      letter-spacing: -0.6px;
    }

    & .date {
      color: $g04;
      font-size: 14px;
      font-weight: 400;
      line-height: 120%;
      letter-spacing: -0.6px;
    }
  }
}
</style>
